<template>
  <modal 
    name="third-party-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'620px'"
    :adaptive="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Please select a {{ label.toLowerCase() }}
      </div>

      <a href="#"
        v-on:click.prevent="close"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">

      <div class="text-sm">
        Please select a {{ label.toLowerCase() }} that was used for one of your previous clients from below list
      </div>

      <div class="form-line">
        <select class="select-standard h-10" v-model="selectedThirdParty">
          <option :value="null">Please select {{ label.toLowerCase() }}</option>

          <template v-for="(tp, index) in thirdParties">
            <option :value="tp.id">{{ tp.contact_first }} {{ tp.contact_last }} - {{ tp.email }}</option>
          </template>
        </select>
      </div>

      <div class="button-line">
        <SubmitButton2 :onClick="submit" :loading="loading" label="Submit" />
      </div>

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        loading           : false,
        type              : null,
        label             : '',
        onSelected        : null,
        thirdParties      : null,
        selectedThirdParty: null
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading            = false
        this.type               = event.params.type
        this.label              = event.params.label
        this.onSelected         = event.params.onSelected
        this.selectedThirdParty = null
        
        this.apiGet({
          brokerId: this.$store.state[this.$store.state.view + 'Module'].broker.id,
          type    : this.type
        }, 'third-party/data', (thirdParties) => {
          this.thirdParties = thirdParties
        })
      },

      opened(event) {

      },

      close() {
        this.$modal.hide('third-party-modal')
      },

      submit() {
        let valid = true

        if(valid) {
          this.onSelected(this.selectedThirdParty)
          this.close()
        }
      }
    }
  }
</script>